import { type Theme, createTheme } from '@mui/material/styles';

const DISABLED_BTN_SELECTOR = '&.Mui-disabled';
const HOVERED_BTN_SELECTOR = '&:hover';

const getBaseStyles = (theme: Theme, ownerState: Record<string, unknown>) => ({
  ...(ownerState['variant'] === 'contained' && {
    color: theme.colors.baseColor,
    backgroundColor: theme.colors.baseBackground,
  }),
  ...(ownerState['variant'] === 'outlined' && {
    color: theme.colors.baseBackground,
    backgroundColor: theme.colors.baseColor,
  }),
});

const getHoverStyles = (theme: Theme, ownerState: Record<string, unknown>) => ({
  color: theme.colors.baseColor,
  backgroundColor: theme.colors.secondaryBackground,
  ...(ownerState['variant'] === 'contained' && {
    backgroundColor: theme.palette.primary.main,
    ...(ownerState['color'] === 'secondary' && {
      color: theme.palette.secondary.light,
      backgroundColor: theme.palette.secondary.dark,
    }),
  }),
  ...(ownerState['variant'] === 'outlined' && {
    color: theme.palette.primary.main,
  }),
  ...(ownerState['variant'] === 'text' && {
    color: ownerState['main'],
  }),
});

export const overrideButtonStyles = (theme: Theme): Theme => {
  return createTheme(theme, {
    components: {
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }: { ownerState: Record<string, unknown> }) => ({
            borderRadius: '25px',
            height: '46px',
            padding: '0 25px',
            ...getBaseStyles(theme, ownerState),

            [HOVERED_BTN_SELECTOR]: getHoverStyles(theme, ownerState),
            [DISABLED_BTN_SELECTOR]: {
              opacity: 0.5,
            },
          }),
        },
      },
    },
  });
};
